import { useQuery } from "@tanstack/react-query";
import { getExperiences } from "@/services/adminApi";

export function useAdminExperiences(status?: string, limit = 50) {
  return useQuery({
    queryKey: ["admin", "experiences", status, limit],
    queryFn: () => getExperiences(status, limit),
  });
}
